module.exports = __webpack_public_path__ + "img/adulto34.d7579f3f.jpg";